import React from 'react';
import api from 'controllers/raymanAPI';
import Singletons from 'controllers/Singletons';

function map(item)
{
    return {...item, id: item.stepIndex}
}

async function getData(taskID)
{
    let indexed = {};

    let response = await api.procedures.tasks.reports.getAll(taskID);
    let data = await response.json();
    data = data.map((item)=>map(item));
    data.forEach(item => {
        indexed[item.stepIndex] = item
    });
    
    return {array: data, indexed: indexed};
}

const TaskReportsCtx = React.createContext({
    loading: true, 
    data: {
        array: [], 
        indexed: {}
    }, 
    // funcs: {
    //     create: () => {},
    //     update: () => {},
    //     delete: () => {},
    // }
});

function TaskReportsCtxProvider({taskID, ...props})
{

    const [loading, setLoading] = React.useState(true);
    const [data, setData] = React.useState({array: [], indexed: []});

    React.useEffect(() => {
        if(!taskID) return;
        getData(taskID).then(values => {
            setData(values);
            setLoading(false);
        });
    }, [taskID]);

    const internalRefresh = React.useCallback(() => {
        getData(taskID).then(values => {
            setData(values);
            setLoading(false);
        });
    }, [taskID]);

    const internalUpdate = React.useCallback((stepIndex, reportData) => {
        let tmp = {...data};
        if(reportData.order && reportData.order !== tmp.indexed[stepIndex].order) internalRefresh();
        else {
            Object.keys(reportData).forEach((key) => {
                tmp.indexed[stepIndex][key] = reportData[key];
            })
            setData(tmp);
        }
    }, [data, internalRefresh]);

    const internalAdd = React.useCallback(async (stepIndex, item) => {
        if(!taskID) return;
        if(data.indexed[stepIndex] !== undefined) return internalUpdate(stepIndex, map(item));
        
        let tmp = {...data};
        item = map(item);
        let index = tmp.array.push(item);
        tmp.indexed[item.id] = tmp.array[index-1];
        setData(tmp);
    }, [internalUpdate, taskID, data]);

    
    // const internalDelete = React.useCallback((stepIndex) => {
    //     let tmp = {...data};
    //     let item = tmp.indexed[stepIndex];

    //     // remove from array
    //     let index = tmp.array.indexOf(item);
    //     if(index > -1) tmp.array.splice(index,1);

    //     delete tmp.indexed[stepIndex];
    //     setData(tmp);
    // }, [data]);    


    // const create = React.useCallback(async (data) => {
    //     if(!taskID) return;
    //     let result = await api.procedures.tasks.reports.post(taskID, data);
    //     if(result.ok)
    //     {
    //         let report = await result.json();
    //         await internalAdd(report.stepIndex, report);
    //         return report;
    //     }
    // }, [taskID, internalAdd]);

    // const update = React.useCallback(async (stepIndex, data) => {
    //     if(!taskID) return;
    //     let result = await api.procedures.tasks.reports.updateSingle(taskID, stepIndex, data);
    //     if(result.ok) internalUpdate(stepIndex, map(await result.json()));

    // }, [taskID, internalUpdate]);

    // const remove = React.useCallback(async (stepIndex) => {
    //     if(!taskID) return;
    //     let result = await api.procedures.tasks.reports.deleteSingle(taskID, stepIndex);
    //     if(result.ok) internalDelete(stepIndex);
    // }, [taskID, internalDelete]);

    React.useEffect( function handleNotifications() {

        const handleCreate = (message) => internalAdd(message.stepIndex, message);
        // const handleEnable = (message) => internalUpdate(message.stepIndex, {disabled: false});
        // const handleDisable = (message) => internalUpdate(message.stepIndex, {disabled: true});
        const handleUpdate = (message) => internalUpdate(message.stepIndex, map(message));
        // const handleDelete = (message) => internalDelete(message.stepIndex, message);

        Singletons.NotificationsSocket.on('procedures.tasks.reports.created', handleCreate);
        // Singletons.NotificationsSocket.on('procedures.tasks.reports.disabled', handleDisable);
        // Singletons.NotificationsSocket.on('procedures.tasks.reports.enabled', handleEnable);
        Singletons.NotificationsSocket.on('procedures.tasks.reports.updated', handleUpdate);
        // Singletons.NotificationsSocket.on('procedures.tasks.reports.deleted', handleDelete);

        return () => {
            Singletons.NotificationsSocket.off('procedures.tasks.reports.created', handleCreate);
            // Singletons.NotificationsSocket.off('procedures.tasks.reports.disabled', handleDisable);
            // Singletons.NotificationsSocket.off('procedures.tasks.reports.enabled', handleEnable);
            Singletons.NotificationsSocket.off('procedures.tasks.reports.updated', handleUpdate);
            // Singletons.NotificationsSocket.off('procedures.tasks.reports.deleted', handleDelete);
        }

    }, [internalAdd, internalUpdate]);

    return <TaskReportsCtx.Provider value={{loading: loading, data: {...data}}} >
        {props.children}
        </TaskReportsCtx.Provider>
}

export {TaskReportsCtx, TaskReportsCtxProvider};